import { addBanner } from "@/business/banner/application/addBanner";
import { removeBanner } from "@/business/banner/application/removeBanner";
import { getAllBanners } from "@/business/banner/application/getAllBanners";
import { Banner } from "@/business/banner/domain/banner";
import { ref, Ref, onMounted } from "vue";

export function bannersUse() {
  const banners: Ref<Banner[]> = ref([]);
  const selectedBanner: Ref<Banner | null> = ref(null);

  onMounted(async () => {
    await getBannersFromApi();
  });

  async function getBannersFromApi(): Promise<void> {
    banners.value = await getAllBanners.execute();
  }

  async function createBannerOperation(image: File) {
    const position = banners.value.length;
    await addBanner.execute(position.toString(), image);
    await getBannersFromApi();
  }

  async function deleteBannerOperation() {
    const bannerToDelete = selectedBanner.value;
    if (bannerToDelete !== null && bannerToDelete.position !== null) {
      await removeBanner.execute(bannerToDelete.position);
      banners.value = banners.value.filter(
        (banner) => bannerToDelete.position !== banner.position
      );
    }
  }

  return {
    banners,
    createBannerOperation,
    deleteBannerOperation,
    selectedBanner,
  };
}
